import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs/rx";
import "rxjs/observable/combineLatest";
import "rxjs/add/observable/of";

import { ISprintSequence } from "../../interfaces/models/sprint-sequence/i-sprint-sequence";
import { ISequenceCombo } from "../../interfaces/models/sequence/i-sequence-combo";
import { IExercise } from "../../interfaces/models/i-exercise";

import { ComboSequenceService } from "../combo-sequence.service";
import { ExerciseService } from "../exercise.service";
import { NotificationService } from "../notification.service";
import { SprintSequenceService } from "../sprint-sequence.service";

import { CONFIG } from "../../../assets/config";


@Injectable()
export class SprintSequenceConfiguratorResolver implements Resolve<ISprintSequence> {

  constructor(private notificationService: NotificationService,
    private exerciseService: ExerciseService,
    private sequenceService: SprintSequenceService,
    private router: Router
  ) { }

  resolve(route: ActivatedRouteSnapshot): Observable<ISprintSequence> {

    if (CONFIG.traceLoads) {
      console.log("---- SEQUENCE FORM RESOLVER -------------- LOADING DATA--------------------------");
    }

    const param = route.params["exerciseId"];
    const paramId = Number(param);
    if (!param) {
      this.router.navigate(["/exercises"]);
    } else if (isNaN(paramId) || paramId === 0) {
      return Observable.of(null);
    } else {
      return Observable
        .combineLatest(
          this.exerciseService.getExercise(paramId),
          this.sequenceService.getSprintSequence(paramId),
          this.sequenceService.getSequenceTypes(),
        )
        .map( (data: any[]) => {
          if (CONFIG.traceLoads) {
            console.log("------------------------------DATA LOADED--------------------------");
          }

          const sequence: ISprintSequence = data[1];
          sequence.exercise = data[0];
          sequence.exerciseId = sequence.exercise.id;

          return sequence;
        });
    }
  }
}
